const STORAGE_KEY = 'interestedEventsById';

export const loadInterestedEventsById = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) {
      return {};
    }
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (error) {
    console.warn('Failed to load interested events:', error);
    return {};
  }
};

export const saveInterestedEventsById = (eventsById) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(eventsById));
  } catch (error) {
    console.warn('Failed to save interested events:', error);
  }
};

export const clearInterestedEventsById = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.warn('Failed to clear interested events:', error);
  }
};
